import { render, staticRenderFns } from "./ReportPeriodicContent.vue?vue&type=template&id=9830fc46&scoped=true&"
import script from "./ReportPeriodicContent.vue?vue&type=script&lang=js&"
export * from "./ReportPeriodicContent.vue?vue&type=script&lang=js&"
import style0 from "./ReportPeriodicContent.vue?vue&type=style&index=0&id=9830fc46&lang=scss&scoped=true&"
import style1 from "./ReportPeriodicContent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9830fc46",
  null
  
)

export default component.exports